import {
  ProductKeys,
  ProductKeysBrPf,
  TEntity,
  TProductKey,
  TProductKeysBrPf,
  ProductKeysBrPj,
  TProductKeysBrPj,
} from 'contexts/app-context/types'

export const isValidProductId = <Entity extends TEntity>(
  entity?: Entity,
  productId?: string,
): TProductKeysBrPf | TProductKey | TProductKeysBrPj | undefined => {
  if (!productId) return undefined
  if (!entity) return undefined

  if (entity === 'BR' && ProductKeysBrPf.includes(productId as TProductKeysBrPf))
    return productId as TProductKeysBrPf

  if (entity === 'BR' && ProductKeysBrPj.includes(productId as TProductKeysBrPj))
    return productId as TProductKeysBrPj

  if (ProductKeys.includes(productId as TProductKey)) return productId as TProductKey

  return undefined
}
